import { ComponentType, useCallback, useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { Product, ProductGroup } from "../types/product"
import { SearchResult } from '../types/search'
import { Theme } from "../types/theme"
import { useServer } from "./providers/server"
import { useTheme } from "./providers/theme"

const ProductGroups: ComponentType<Props> = ({ View }) => {
    const seatId = useParams().seatId!
    const server = useServer()
    const theme = useTheme()
    const navigate = useNavigate()
    const [{ list, total }, setResult] = useState<SearchResult<ProductGroup>>({ list: [], total: 0 })
    const fetchAsync = useCallback(async () => {
        setResult(await server.searchProductGroups({ page: 1, perPage: 10 }))
    }, [server])
    useEffect(() => {
        fetchAsync()
    }, [fetchAsync])
    const handleClick = (item: ProductGroup) => {
        navigate(`/seat=${seatId}/products/group=${item.id}`)
    }
    return (
        <View
            list={list}
            total={total}
            onClick={handleClick}
            theme={theme}
            onClickPayment={() => {
                navigate(`/seat=${seatId}/table-order-payment`)
            }}
            paymentButtonLabel="お会計"
            title="テーブルオーダー"
        />
    )
}

export default ProductGroups

export type ProductGroupsViewType = ComponentType<{
    list: ProductGroup[]
    total: number
    onClick: (item: ProductGroup) => any
    theme: Theme
    paymentButtonLabel: string
    onClickPayment: () => any
    title: string
}>

interface Props {
    View: ProductGroupsViewType
}
